import { Component, OnInit, ViewChild, ElementRef, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { Sim } from '../../models/sim';
import { NgbModalRef, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormBuilder, Validators, FormControl} from '@angular/forms';
import { Train } from '../../../trains/models/train';
import { Project } from "../../../project/models/project";
import { FormValidationService } from '../../../../shared/services/form-validation.service';
import { Subscription } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-sim-edit',
  template: require('./sim-edit.component.html'),
  styles: [require('./sim-edit.component.sass')]
})
export class SimEditComponent implements OnInit, OnDestroy {

  @ViewChild('simEditModal') simEditModal: ElementRef;
  @Input() projectId: number;
  @Input() projects: Project[];
  @Input() trains: Train[];
  @Input() operators: any[];
  @Input() pools: any[];
  @Input() sims: Sim[];

  @Output() saveSim = new EventEmitter<Sim>();

  sim: Sim | undefined;
  simForm: FormGroup;
  simEditModalReference: NgbModalRef;

  dateFormat="dd/mm/yy"
  languageChangeSubscription: Subscription;
  locale = environment.calendar.locales['en'];
  
  constructor(
    private fb: FormBuilder,
    private modalService: NgbModal,
    public formValidation: FormValidationService,
    private translate: TranslateService
  ) {
    this.locale = environment.calendar.locales[this.translate.currentLang];
    this.simForm = this.fb.group({
      iccid: ['', [Validators.required, Validators.pattern(/^[0-9]\d{15,19}$/)]],
      projectId: [null, Validators.required],
      trainId: ['', Validators.required],
      boxId: ['', Validators.required],
      linkNumber: ['', Validators.required],
      timestamp: [],
      simConfig: new FormGroup(
          {
            simId: new FormControl(),
            msisdn: new FormControl(),
            poolId: new FormControl(),
            operatorCode: new FormControl(),
            startDate: new FormControl('',Validators.required),
            limit: new FormControl(),
            national: new FormControl()
          }
      )
    });
    
   }

  ngOnInit(): void {
    this.languageChangeSubscription = this.translate.onLangChange.subscribe(() => {
      this.locale = environment.calendar.locales[this.translate.currentLang];
    })
  }

  async showModal(sim?: Sim) {
    this.simForm.reset();
    this.sim = sim;
    let simData;
    if (this.sim && this.sim.id) {
      simData = {
        id: this.sim.id,
        iccid: this.sim.iccid,
        projectId: this.sim.projectId,
        trainId: this.sim.trainId,
        boxId: this.sim.boxId,
        linkNumber: this.sim.linkNumber,
        timestamp: this.sim.timestamp,
        simConfig: {
          simId: this.sim.simConfig.simId,
          msisdn: this.sim.simConfig.msisdn,
          poolId: this.sim.simConfig.poolId,
          operatorCode: this.sim.simConfig.operatorCode,
          startDate: new Date(this.sim.simConfig.startDate),
          limit: parseFloat(String(this.sim.simConfig.limit as string).replace(/,/g, '')),
          national: this.sim.simConfig.national
        }
      };
    } else {
      const today = new Date();
      simData = {
        projectId: this.projectId,
        timestamp: new Date(),
        simConfig: {
          national: false,
          startDate: today
      }
    }
  }
    this.simForm.patchValue(simData);

    this.simEditModalReference = await this.modalService.open(this.simEditModal, {
      size: 'xl',
      backdrop: 'static'
    });
  }

  save = () => {
    if (this.simForm.valid) {
        const sim: Sim = {
          ...this.simForm.value
        }
        sim.link = "CELL_" + sim.linkNumber;
        sim.simConfig.msisdn = sim.simConfig.msisdn || "";
        sim.simConfig.poolId = sim.simConfig.poolId ? parseInt(sim.simConfig.poolId.toString()) : 0;
        if (this.sim && this.sim.id) {
          sim.id = this.sim.id;
        }
        delete sim.linkNumber;
        this.saveSim.emit({ ...sim });
        this.simEditModalReference.close();
    } else {
      this.formValidation.validateAllFormFields(this.simForm);
    }

  };

    onKeyPressEvent(event: any) {
      if(isNaN(event.key)) {
        event.preventDefault();
      }

      if(event.target.value.length === 20){
        event.preventDefault();
      };
    }

    ngOnDestroy() {
      if (this.languageChangeSubscription) {
        this.languageChangeSubscription.unsubscribe();
      }
    }
}
